module.exports = __webpack_public_path__ + "static/media/Bowen Catch.4cca55ba.jpg";